import React from 'react';

const withModal = (WrappedComponent) =>
  class WithModal extends React.Component {
    state = { isOpen: false };

    componentWillUnmount() {
      this.setState({ isOpen: false });
    }

    openModal = () => this.setState({ isOpen: true });

    closeModal = () => {
      this.setState({ isOpen: false });
    };

    render() {
      const { isOpen } = this.state;

      return (
        <WrappedComponent
          {...this.props}
          isOpen={isOpen}
          handleClose={this.closeModal}
          handleOpen={this.openModal}
        />
      );
    }
  };

export default withModal;
